import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTE_CODE_CATEGORIES, ROUTE_CODE_CATEGORIES_DETAILS, ROUTE_CODE_CATEGORIES_CROSSWALK } from '../../constants';
import Suspense from '../../services/lazyLoad/Suspense';

const CodeCategories = React.lazy(() => import('./CodeCategories'));
const CodeCategoriesDetails = React.lazy(() => import('./Details'));
const CodeCategoriesCrosswalk = React.lazy(() => import('./Crosswalk'));

export default function CodeCategoriesWrapper() {
  return (
    <Suspense>
      <Switch>
        <Route exact path={ROUTE_CODE_CATEGORIES_CROSSWALK.path}>
          <CodeCategoriesCrosswalk />
        </Route>
        <Route exact path={ROUTE_CODE_CATEGORIES_DETAILS.path}>
          <CodeCategoriesDetails />
        </Route>
        <Route exact path={ROUTE_CODE_CATEGORIES.path}>
          <CodeCategories />
        </Route>
        <Redirect exact path="/*" to={ROUTE_CODE_CATEGORIES.path} />
      </Switch>
    </Suspense>
  );
}
